import classNames from 'classnames';
import _ from 'lodash';
import { FC } from 'react';
import CustomButton from '../customButton';
import type { IProps } from './types';
import './styles.scss';

const ViewMoreButton: FC<IProps> = ({ className = '', icons }) => (
  <div className={classNames('view-more-button', className)}>
    {_.map(icons, (item) => {
      const { id, content, ...rest } = item;
      return (
        <CustomButton
          style="neutral"
          type="tertiary"
          key={id}
          id={id}
          tooltipClassName="view-more-button__tooltip"
          ariaLabel={typeof rest.tooltipTitle === 'string' ? rest.tooltipTitle : undefined}
          {...rest}
        >
          {content}
        </CustomButton>
      );
    })}
  </div>
);

export default ViewMoreButton;
